module.exports = __webpack_public_path__ + "static/media/sf-test-7.44f895a0.mp3";